var sizemodal = document.getElementById("myModal");
var btn = document.getElementById("myBtn");

var span = document.getElementsByClassName("close")[0];

btn.onclick = function () {
  sizemodal.style.display = "block";
};

span.onclick = function () {
  sizemodal.style.display = "none";
};

window.onclick = function (event) {
  if (event.target == sizemodal) {
    sizemodal.style.display = "none";
  }
};
